<template>
    <h3 class="txt txt--lg square-title">
        <v-row no-gutters align="center">
            <v-col cols="auto">
                <v-sheet color="primary" class="square" />
            </v-col>
            <v-col class="grey--text text--darken-4">
                <slot />
            </v-col>
        </v-row>
    </h3>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.square-title {
    margin-bottom: 20px;
}
.square {
    margin-right: 6px;
    width: 14px;
    height: 14px;
}
@media (min-width: 768px) {
    .square-title {
        margin-bottom: 24px;
    }
    .square {
        margin-right: 8px;
        width: 16px;
        height: 16px;
    }
}
</style>